@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

.grouped-notification-container {
  position: relative;
  background-color: var(--white);
  border-bottom: 1px solid var(--grey-200);
  padding: @space-12 0;
  display: flex;
  flex-direction: column;
  gap: @space-4;
  cursor: pointer;

  &:hover {
    background-color: var(--grey-100);
  }
}

.row1 {
  padding: 0 @space-16;
  align-items: center;
}

.group-count {
  font-size: 14px;
  font-weight: 400;
  color: var(--grey-600);
  line-height: 24px;
}

.category-label {
  color: var(--grey-600);
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}

.group-items-container {
  padding-left: @space-16;
  display: flex;
  flex-direction: column;
}

.group-items {
  border-left: 1px solid var(--grey-400);
  display: flex;
  flex-direction: column;
}

.expand-button-container {
  padding: 0 @space-16;
  display: flex;
  justify-content: flex-start;
}

.expand-button {
  font-size: 14px;
  line-height: 20px;
  padding: 2px 0;
  flex-shrink: 0;
  color: var(--blue-600);
  display: flex;
  align-items: center;
  gap: @space-4;

  &:hover {
    color: var(--blue-700);
    text-decoration: underline;
  }

  svg {
    width: 10px;
    height: 10px;
    padding-top: 1px;
  }
}
